import { IVanFetch } from 'src/models/IVan';

type IFilterVan = Pick<IVanFetch, 'id' | 'location' | 'make' | 'type' | 'year'>;

const createVanURL = (filter: IFilterVan) => {
  const location = filter.location.split(' - ');
  let city;
  if (location.length > 1) {
    city = location[1].replaceAll(' ', '');
  } else city = location[0].replaceAll(' ', '');
  const make = filter.make!.replaceAll(' ', '');

  return `/van/${location[0]}/${city}/${make}/${filter.type}/${filter.year}/143${filter.id}`;
};

export default createVanURL;
